import { render, staticRenderFns } from "./ComplaintProposalPraise.vue?vue&type=template&id=00466a53"
import script from "./ComplaintProposalPraise.vue?vue&type=script&lang=js"
export * from "./ComplaintProposalPraise.vue?vue&type=script&lang=js"
import style0 from "./ComplaintProposalPraise.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports